import * as FaIcons from "react-icons/fa";
import * as MdIcons from "react-icons/md";
// Add more sets if needed

const iconLibraries = {
  ...FaIcons,
  ...MdIcons,
};

export const getIconComponent = (iconName) => {
  return iconLibraries[iconName] || null;
};

// ✅ Search icons by name (case-insensitive)
export const searchIcons = (searchText = "") => {
  const lowerText = searchText.toLowerCase();

  return Object.keys(iconLibraries)
    .filter((key) => key.toLowerCase().includes(lowerText))
    .slice(0, 5);
};
